module.exports = __webpack_public_path__ + "img/sixpackcarrier90.a17b8f19.jpg";